module.exports = __webpack_public_path__ + "0af5d249/img/arrow-left-icon.785c715c.svg";